export const TANK_CLASSES = {
    mbt_standard: {
        id: 'mbt_standard',
        name: 'T-72M Main Battle Tank',
        description: 'Versatile low-profile battle tank with reliable sloped armor and a high-velocity 125mm smoothbore cannon.',
        country: 'Standard',
        role: 'Main Battle Tank',
        maxSpeedKmh: 50,
        armorRating: 7,
        firepowerRating: 8,
        mobilityRating: 7,
        defaultColor: '#4b5320', // Olive Drab
    },
    leopard_2: {
        id: 'leopard_2',
        name: 'Leopard 2A4',
        description: 'Advanced composite armor, superior gun stabilization, and exceptional reverse maneuvering speed.',
        country: 'Western',
        role: 'Main Battle Tank',
        maxSpeedKmh: 58,
        armorRating: 8,
        firepowerRating: 8,
        mobilityRating: 8,
        defaultColor: '#556b2f', // Dark Olive Green
    },
    abrams_m1: {
        id: 'abrams_m1',
        name: 'M1A1 Abrams',
        description: 'Heavy turbine-powered armored behemoth featuring reinforced frontal turret cheeks and high-explosive squash head shells.',
        country: 'Allied',
        role: 'Heavy Tank',
        maxSpeedKmh: 54,
        armorRating: 9,
        firepowerRating: 9,
        mobilityRating: 6,
        defaultColor: '#b8860b', // Desert Tan
    },
};
//# sourceMappingURL=index.js.map